import "./modernInvoiceForm.css";
import Client from "./components/client";
import Products from "./components/product";
import Description from "./components/note";
import InvoiceSummary from "./components/InvoiceSummary";
import {
    Paper, Typography, Divider, Box, Grid, TextField, Button, Stack, IconButton,
    Tooltip, Collapse, Chip, Checkbox, FormControlLabel
} from "@mui/material";

import { generate_invoice_post, send_invoice_post, download_invoice_get } from "../../../services/invoices/invoices";
import { useEffect, useMemo, useState } from "react";
import { pagination_method_ts } from "../../../main_components/pagination/pagination_ts";
import GENERAL_FORM from "../../../main_components/material_table/general_form";

import {
    address_businesspartners_get,
    data_businesspartners_get,
    bussines_partnert_post,
    bussines_partnert_put,
    code_businesspartners_get
} from "../../../services/businesspartners/businesspartners";

import { base64toBlobxml, base64toBlob } from "../../../main_components/donwloadfuncion/download";

import ProcessPanel from "../../../main_components/modal/process_panel";

import {
    processed_format,
    updated_form_data,
    validate_data,
} from "../../../component_businessPartner/business_partner/bussines_partner_ts/tools/auxiliar_funtions";
import { inf_partner } from "../../../component_businessPartner/business_partner/bussines_partner_ts/tools/inf_partner";
import { inf_partner_qr_invoice } from "../../../component_businessPartner/business_partner/bussines_partner_ts/tools/inf_partner_qr_invoice";
import { inf_partner_img_qr_invoice } from "../../../component_businessPartner/business_partner/bussines_partner_ts/tools/inf_partner_img_qr_invoice";
import { Menu, MenuItem, Fade } from "@mui/material";

import payMethod from "../../../dataComponets/invoice/metodoPago.json";
import payForm from "../../../dataComponets/invoice/formaPago.json";
import moneyForm from "../../../dataComponets/invoice/moneda.json";

import CUSTOM_DIALOG from "../../../main_components/modal/custom_dialog";
// import JOIN_INVOICE from "../join_invoice2/join_invoice";
import JOIN_INVOICE from "../join_invoice2/join_invoice";
import { useRelacionados } from "../../../hooks/useRelacionados";
import SNACK_ALERT from "../../../main_components/alerts/snack_alert";

import type { Option, ProductoAgregado, ProcKind } from "./types/modernInvoiceForm";
import { bussinesPartnerSteps, invoiceSteps } from "./constants/steps";

import { useClientSection } from "./hooks/useClientSection";
import { useProductsSection } from "./hooks/useProductsSection";
import { useDescriptionSection } from "./hooks/useDescriptionSection";
import { useInvoiceSummarySection } from "./hooks/useInvoiceSummarySection";
import { useInvoiceDrafts, type InvoiceDraftData } from "./hooks/useInvoiceDrafts";
// --- helpers locales que sí usamos ---
function parseEmails(raw: unknown): string[] {
    if (raw == null) return [];
    let parts: string[] = [];
    if (Array.isArray(raw)) {
        parts = raw.filter((x): x is string => typeof x === "string");
    } else if (typeof raw === "string") {
        parts = raw.split(/[,;\s]+/g);
    } else {
        return [];
    }
    const out = new Set<string>();
    for (const p of parts) {
        const e = String(p).trim().toLowerCase();
        if (e && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(e)) out.add(e);
    }
    return Array.from(out);
}



// Tipos opcionales para que no grite TS
type DownloadData = {
    file?: string;
    id_invoice?: number;
    uuid?: string;
};
type DownloadResp = { data?: DownloadData } | any;

// ↓↓↓ devolvemos la respuesta del back
async function downloadFile(tipo: "pdf" | "xml", filename: string): Promise<DownloadResp> {
    const res = await download_invoice_get(tipo, filename, 0);
    const b64 = res?.data?.file;
    if (!b64) throw new Error("Archivo vacío");

    const blob = tipo === "xml" ? base64toBlobxml(b64) : base64toBlob(b64);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const parts = String(filename).split("/");
    a.download = (parts[4] || "documento") + `.${tipo}`;
    a.click();
    URL.revokeObjectURL(url);

    return res; // <-- **importante**
}

async function downloadWithRetries(
    tipo: "pdf" | "xml",
    filename: string,
    retries = 5,
    delayMs = 5000,
    facturaGenerada = false
): Promise<DownloadResp> {      // <-- tipar retorno
    for (let i = 0; i < retries; i++) {
        try {
            const res = await downloadFile(tipo, filename);
            return res;               // <-- **importante**
        } catch (err) {
            console.warn(`Intento ${i + 1}/${retries} fallido. Reintentando en ${Math.round(delayMs / 1000)}s...`);
            if (i < retries - 1) {
                await new Promise((r) => setTimeout(r, delayMs));
            } else {
                if (facturaGenerada) {
                    alert("La factura sí se timbró, pero no fue posible descargar el documento. Descárgalo desde 'Consultar Facturas'.");
                } else {
                    alert("No fue posible descargar la previsualización.");
                }
                throw err;
            }
        }
    }
}




// ------- helpers para totales y mapeo de conceptos -------
function calcularTotalesDeRenglon(p: any) {
    const qty = Number(p.cantidad || 0);
    const unit = Number(p.precio || p?.concepto?.valor_unitario || 0);

    const subtotal = Number(p.importe ?? qty * unit);
    const descuento = Number(p.descuento || 0);

    const totalTraslados =
        (p.impuestos?.traslados || [])?.reduce((a: number, t: any) => a + Number(t?.importe || 0), 0) || 0;
    const totalRetenciones =
        (p.impuestos?.retenciones || [])?.reduce((a: number, r: any) => a + Number(r?.importe || 0), 0) || 0;
    const impuestosFederales = totalTraslados - totalRetenciones;

    const totalLocalesTras =
        (p.implocales?.traslados || [])?.reduce((a: number, l: any) => a + Number(l?.importe || 0), 0) || 0;
    const totalLocalesRet =
        (p.implocales?.retenciones || [])?.reduce((a: number, l: any) => a + Number(l?.importe || 0), 0) || 0;
    const impuestosLocales = totalLocalesTras - totalLocalesRet;

    const total = subtotal - descuento + impuestosFederales + impuestosLocales;

    return { subtotal, descuento, impuestosFederales, impuestosLocales, total };
}

function mapProductosAConceptos(productos: any[]) {
    return productos.map((p) => ({
        concept: p?.concepto?.concept ?? "",
        descripcion: p?.descripcion ?? p?.concepto?.descripcion ?? "",
        unidad: p?.unidad ?? p?.concepto?.unidad ?? "",
        valorunitario: Number(p?.precio ?? p?.concepto?.valor_unitario ?? 0),
        cantidad: Number(p?.cantidad ?? 1),
        descuento: p?.descuento ?? null,
        importe: p?.importe ?? null,
        objeto_imp: p?.objeto_imp ?? null,
        claveprodserv: p?.clave_prod_serv ?? "",
        claveunidad: p?.clave_unidad ?? "",
        noidentificacion: p?.no_identificacion === '' ? null : p?.no_identificacion ?? null,
        impuestos: p?.impuestos ?? null,
        implocales: p?.implocales ?? null,
    }));
}

function calcularTotalesFactura(productos: any[]) {
    return productos.reduce(
        (acc, p) => {
            const t = calcularTotalesDeRenglon(p);
            acc.subtotal += t.subtotal;
            acc.descuento += t.descuento;
            acc.total_tra_ret += t.impuestosFederales;
            acc.total_loc += t.impuestosLocales;
            acc.total += t.total;
            return acc;
        },
        { subtotal: 0, descuento: 0, total_tra_ret: 0, total_loc: 0, total: 0 }
    );
}

export default function ModernInvoiceForm() {
    // ---- hooks secciones
    const {
        relModalOpen,
        open,
        close,
        confirmRelacion,
        cfdirelacionados,
        remove,
        setCfdirelacionados,
    } = useRelacionados();

    const client = useClientSection({
        cfdirelacionados,
        setCfdirelacionados,
    });

    const products = useProductsSection({
        selectedCliente: client.selectedCliente,
        notify: (text, severity = "warning") =>
            setSnackbarsConfig((prev) => ({
                ...prev,
                open: true,
                text,
                severity,
                size: "lg",
                autoHideDuration: 10000,
                anchorOrigin: { vertical: "bottom", horizontal: "right" },
            })),
    });

    const description = useDescriptionSection("");

    const summary = useInvoiceSummarySection({
        hasSerie: !!client.selectedSerie?.serie?.trim(),
        hasCliente: !!client.selectedCliente,
        hasConcepto: (products.productosAgregados?.length ?? 0) > 0,
    });

    const drafts = useInvoiceDrafts(); // { list, saveDraft, removeDraft, getDraft, currentDraftId, setCurrentDraftId }
    const [draftsModalOpen, setDraftsModalOpen] = useState(false);



    // --- catálogos de selects (siguen viniendo del JSON)
    const listaMetodoPago: Option[] = (payMethod as Option[]) || [];
    const listaFormaPago: Option[] = (payForm as Option[]) || [];
    const listaMonedas: Option[] = (moneyForm as Option[]) || [];

    // --- snackbar y proceso
    const [snackbarsConfig, setSnackbarsConfig] = useState({
        open: false,
        text: "¡Éxito!",
        severity: "success" as any,
        size: "md" as any,
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "bottom", horizontal: "right" } as const,
    });

    const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
    const [proc, setProc] = useState<{ open: boolean; kind: ProcKind; title: string; progress: number }>({
        open: false,
        kind: "invoice",
        title: "Generando Factura",
        progress: 0,
    });
    const PROCESS_STEPS: Record<ProcKind, any[]> = { invoice: invoiceSteps, bp: bussinesPartnerSteps };
    const DEFAULT_TITLES: Record<ProcKind, string> = {
        invoice: "Generando Factura",
        bp: "Procesando Socio de Negocios",
    };
    const startProcess = (kind: ProcKind, title?: string) =>
        setProc({ open: true, kind, title: title ?? DEFAULT_TITLES[kind], progress: 0 });
    const stepProcess = async (pct: number, delay = 500) => {
        setProc((s) => ({ ...s, progress: pct }));
        await sleep(delay);
    };
    const finishProcess = (delay = 300) =>
        setTimeout(() => setProc((s) => ({ ...s, open: false, progress: 0 })), delay);

    // --- QR / BP form
    const [bpFormOpen, setBpFormOpen] = useState(false);
    const [bpFormLoading, setBpFormLoading] = useState(false);
    const [bpFormData, setBpFormData] = useState<any>({});
    const [bpIdentifier, setBpIdentifier] = useState<number | null>(null);
    const [isNewEntry, setIsNewEntry] = useState(false);
    const [methodCustom, setMethodCustom] = useState(false);
    const [open_qr, setOpenQr] = useState(false);
    const [open_img_qr, setOpenImgQr] = useState(false);

    const qrActive = bpFormOpen && methodCustom && open_qr;
    const dataFormToUse = open_img_qr ? inf_partner_img_qr_invoice : open_qr ? inf_partner_qr_invoice : inf_partner;

    useEffect(() => {
        const onUpdateAndClose = () => {
            setBpFormOpen(false);
            client.handleForceRefreshClients();
        };
        window.addEventListener("bp:update-and-close", onUpdateAndClose);
        return () => window.removeEventListener("bp:update-and-close", onUpdateAndClose);
    }, []);

    // --- al cambiar cliente: poblar correos fijos y limpiar extra
    useEffect(() => {
        if (!client.selectedCliente) {
            summary.setCorreosFijos([]);
            summary.setCorreosExtra([]);
            return;
        }
        const fijos = parseEmails(client.selectedCliente.email);
        summary.setCorreosFijos(fijos);
        summary.setCorreosExtra([]);
    }, [client.selectedCliente]);

    // ---- BP helpers
    const openEditPartner = async (idCliente?: number) => {
        if (!idCliente) return;
        setIsNewEntry(false);
        setMethodCustom(false);
        setOpenQr(false);
        setOpenImgQr(false);

        setBpFormLoading(true);
        setBpFormOpen(true);
        setBpIdentifier(idCliente);

        try {
            const [address, partner] = await Promise.all([
                address_businesspartners_get(idCliente).then((r) => r.data),
                data_businesspartners_get(idCliente).then((r) => r.data),
            ]);

            const base = {
                id: idCliente,
                business_partner: client.selectedCliente?.business_partner ?? "",
                rfc: client.selectedCliente?.rfc ?? "",
                cfdi_use: client.selectedCliente?.cfdi_use ?? "",
                tax_regime: client.selectedCliente?.tax_regime ?? "",
            };

            const merged = {
                ...base,
                ...(Array.isArray(address) ? address : address || {}),
                ...(Array.isArray(partner) ? partner : partner || {}),
            };

            setBpFormData(merged);
        } catch (e) {
            console.error("Error precargando socio:", e);
            setBpFormData({});
        } finally {
            setBpFormLoading(false);
        }
    };

    async function fetchCodePartner(): Promise<string | null> {
        try {
            const response = await code_businesspartners_get();
            return String(response?.data?.code ?? "");
        } catch (e) {
            console.error("Error al obtener el código del socio:", e);
            return null;
        }
    }

    const openCreatePartner = () => {
        const base = {
            code: "1000",
            force_code: false,
            business_partner: null,
            rfc: null,
            paymethod: "01",
            allow_invoicing: false,
            name: null,
            first_last_name: null,
            second_last_name: null,
            capital_regime: null,
            cfdi_use: "G03",
            tax_residence: null,
            num_reg_id_trib: null,
            metodo_pago: "PUE",
            tax_regime: "616",
            email: null,
            phone: null,
            enable: true,
            person_type: null,
            zip_code: null,
            street: null,
            city: null,
            outdoor_number: null,
            inside_number: null,
            state: "VERACRUZ DE IGNACIO DE LA LLAVE",
            reference: null,
            outer_code: null,
            account_number: null,
            id_accounting_account_fk: null,
            name_accounting_account: null,
            code_accounting_account: null,
            address_type: "FISCAL",
            country: "MÉXICO",
            town: null,
            subsidiary: "MATRIZ",
            neighborhood: null,
            partner_type: "PROPIO",
            credit_days: null,
            business_partner_type: "CLIENTE",
        };

        setIsNewEntry(true);
        setMethodCustom(false);
        setOpenQr(false);
        setOpenImgQr(false);
        setBpIdentifier(null);
        setBpFormData(base);
        setBpFormOpen(true);

        // pedir código async sin bloquear UI
        fetchCodePartner().then((code) => {
            setBpFormData((prev: any) => ({
                ...prev,
                code: code || prev.code,
                __codeLoading: false,
            }));
            if (!code) {
                setSnackbarsConfig((p) => ({
                    ...p,
                    open: true,
                    text: "No se pudo obtener el código automáticamente. Puedes capturarlo o reintentar.",
                    severity: "warning",
                    autoHideDuration: 6000,
                }));
            }
        });
    };

    const handleCloseQRMenu = () => client.handleCloseQRMenu();
    const handleOpenQRByCamera = () => {
        handleCloseQRMenu();
        setIsNewEntry(true);
        setMethodCustom(true);
        setOpenQr(true);
        setOpenImgQr(false);
        setBpIdentifier(null);
        setBpFormData({});
        setBpFormOpen(true);
    };
    const handleOpenQRByImage = () => {
        handleCloseQRMenu();
        setIsNewEntry(true);
        setMethodCustom(true);
        setOpenQr(false);
        setOpenImgQr(true);
        setBpIdentifier(null);
        setBpFormData({});
        setBpFormOpen(true);
    };

    const handleSaveBP = async (finalObject: any) => {
        const creating = isNewEntry || open_qr || open_img_qr;
        startProcess("bp", creating ? "Creando Socio de Negocios" : "Actualizando Socio de Negocios");

        try {
            await stepProcess(10);
            let targetId: number | null = null;

            if (creating) {
                await stepProcess(30);
                const res = await bussines_partnert_post(finalObject);
                targetId = Number(res?.data?.id ?? null);

                await stepProcess(55);
                await client.handleForceRefreshClients();

                let nuevoSeleccionado = null;
                if (targetId) {
                    try {
                        const partnerFull = await data_businesspartners_get(targetId).then((r) => r.data);
                        nuevoSeleccionado = {
                            id: Number(targetId),
                            business_partner: partnerFull?.business_partner ?? "",
                            rfc: partnerFull?.rfc ?? "",
                            cfdi_use: partnerFull?.cfdi_use ?? null,
                            tax_regime: partnerFull?.tax_regime ?? null,
                            person_type: partnerFull?.person_type ?? null,
                            email: partnerFull?.email ?? null,
                        };
                    } catch {
                        const list = (await pagination_method_ts("bp", null)) as any[];
                        nuevoSeleccionado = list.find((x) => Number(x.id) === Number(targetId)) || null;
                    }
                }

                if (nuevoSeleccionado) {
                    client.onSelectCliente(nuevoSeleccionado);
                }

                await stepProcess(85);
                setSnackbarsConfig((p) => ({ ...p, open: true, text: "Socio creado correctamente", severity: "success" }));
            } else {
                if (!bpIdentifier) return;

                await stepProcess(30);
                await bussines_partnert_put(finalObject, bpIdentifier);

                await stepProcess(60);
                await client.handleForceRefreshClients();

                let actualizado = null;
                try {
                    const partnerFull = await data_businesspartners_get(bpIdentifier).then((r) => r.data);
                    actualizado = {
                        id: Number(bpIdentifier),
                        business_partner: partnerFull?.business_partner ?? "",
                        rfc: partnerFull?.rfc ?? "",
                        cfdi_use: partnerFull?.cfdi_use ?? null,
                        tax_regime: partnerFull?.tax_regime ?? null,
                        person_type: partnerFull?.person_type ?? null,
                        email: partnerFull?.email ?? null,
                    };
                } catch {
                    const list = (await pagination_method_ts("bp", null)) as any[];
                    actualizado = list.find((x) => Number(x.id) === Number(bpIdentifier)) || null;
                }

                if (actualizado) {
                    client.onSelectCliente(actualizado);
                }

                await stepProcess(85);
                setSnackbarsConfig((p) => ({ ...p, open: true, text: "Socio actualizado correctamente", severity: "success" }));
            }

            setBpFormOpen(false);
            await stepProcess(100);
        } catch (e) {
            console.error(e);
            setSnackbarsConfig((p) => ({
                ...p,
                open: true,
                text: "Error al guardar el socio",
                severity: "error",
                autoHideDuration: 6000,
            }));
        } finally {
            finishProcess();
        }
    };

    // ------- generar/previsualizar -------
    const handleGenerar = async (preview = false) => {
        if (!client.selectedCliente) {
            alert("Selecciona un socio de negocios antes de generar.");
            return;
        }
        if (!client.selectedSerie) {
            alert("Selecciona una serie antes de generar.");
            return;
        }
        if (!products.productosAgregados.length) {
            alert("Agrega al menos un concepto antes de generar.");
            return;
        }

        startProcess("invoice", preview ? "Generando Previsualización" : "Generando Factura");
        try {
            await stepProcess(10);

            const tot = calcularTotalesFactura(products.productosAgregados);

            const dt = {
                comprobante: {
                    serie: client.selectedSerie.serie,
                    formapago: summary.formaPago,
                    condicionesdepago: summary.metodoPago === "PPD" ? String(summary.diasCredito || 0) : "PUE",
                    subtotal: Number(tot.subtotal.toFixed(2)),
                    descuento: tot.descuento ? Number(tot.descuento.toFixed(2)) : null,
                    moneda: summary.moneda,
                    tipocambio: summary.moneda === "MXN" ? null : Number(summary.tipoCambio || 0),
                    total: Number(tot.total.toFixed(2)),
                    tipodecomprobante: client.tipo, // "I" | "E"
                    exportacion: "01",
                    metodopago: summary.metodoPago, // "PUE" | "PPD"
                },
                receptor: {
                    id: client.selectedCliente.id,
                    nombre: client.selectedCliente.business_partner,
                    rfc: client.selectedCliente.rfc,
                    usocfdi: client.usoCFDIValue || client.selectedCliente.cfdi_use || "",
                    residenciafiscal: null,
                    numregidtrib: null,
                    regimenfiscalreceptor: client.regimenFiscal || client.selectedCliente.tax_regime || "",
                    domiciliofiscalreceptor: client.selectedCliente.zip_code,
                },
                conceptos: mapProductosAConceptos(products.productosAgregados),
                cfdirelacionados:
                    !cfdirelacionados || cfdirelacionados.length === 0
                        ? null
                        : cfdirelacionados.map((r: any) => ({
                            tiporelacion: r.tiporelacion,
                            uuid: r.uuid,
                        })),
                nota: description.notaAdicional || "",
                preview,
            };

            await stepProcess(35);

            console.log(dt)
            const resp = await generate_invoice_post(dt);
            const fileName = resp?.data?.filename as string | undefined;

            if (!fileName) throw new Error("El backend no devolvió filename");

            await stepProcess(55);
            const res = await downloadWithRetries("pdf", fileName, 5, 5000, !preview);


            const id_invoice = res?.data?.id_invoice as number | undefined;
            const uuid = res?.data?.uuid as string | undefined;

            await stepProcess(80);
            const emails = summary.correosParaEnviar();


            if (!preview && emails.length && id_invoice && uuid) {
                try {
                    await send_invoice_post(id_invoice, uuid, emails.join(","));
                    setSnackbarsConfig((p) => ({ ...p, open: true, text: "Factura enviada por correo", severity: "success" }));
                } catch (err) {
                    console.warn("Falló el envío por correo:", err);
                    setSnackbarsConfig((p) => ({
                        ...p,
                        open: true,
                        text: "La factura se generó, pero no se pudo enviar el correo.",
                        severity: "warning",
                    }));
                }
            }

            await stepProcess(100);

            setSnackbarsConfig((p) => ({
                ...p,
                open: true,
                text: preview ? "Previsualización generada y descargada" : "Factura generada y descargada",
                severity: "success",
            }));

            if (!preview) {
                const activeId = drafts.currentDraftId;
                if (activeId) {
                    drafts.removeDraft(activeId);
                    drafts.setCurrentDraftId(null);
                }
            }

            if (!preview) {
                await resetForNextDocument();
            }
        } catch (e: any) {
            console.error(e);
            setSnackbarsConfig((p) => ({
                ...p,
                open: true,
                text: preview ? "Error al previsualizar" : e.response.data.errorMessage.es || "Error al generar la factura",
                severity: "error",
                autoHideDuration: 6000,
            }));
        } finally {
            finishProcess();
        }
    };

    // // ---- reset para siguiente documento
    // const resetForNextDocument = async () => {
    //     products.resetProducts();      // limpia productos y entradas de captura
    //     description.reset();           // limpia nota
    //     summary.reset();               // PUE/01, MXN/tc=1, días crédito, correos extra
    //     setCfdirelacionados([]);       // limpia relacionados

    //     // refrescar folio/serie
    //     client.handleForceRefreshSeries();
    // };


    function buildCurrentDraft(): InvoiceDraftData {
        return {
            tipo: client.tipo,
            serie: client.selectedSerie?.serie ?? null,
            selectedCliente: client.selectedCliente
                ? {
                    id: client.selectedCliente.id,
                    business_partner: client.selectedCliente.business_partner ?? null,
                    rfc: client.selectedCliente.rfc ?? null,
                    cfdi_use: client.usoCFDIValue || client.selectedCliente.cfdi_use || null,
                    tax_regime: client.regimenFiscal || client.selectedCliente.tax_regime || null,
                    person_type: client.selectedCliente.person_type ?? null,
                    email: client.selectedCliente.email ?? null,
                    zip_code: (client as any).selectedCliente?.zip_code ?? null,
                }
                : null,
            productosAgregados: products.productosAgregados,
            notaAdicional: description.notaAdicional || "",
            cfdirelacionados: (cfdirelacionados || []).map(r => ({ tiporelacion: r.tiporelacion, uuid: r.uuid })),
            metodoPago: summary.metodoPago,
            formaPago: summary.formaPago,
            moneda: summary.moneda,
            tipoCambio: Number(summary.tipoCambio || 0),
            diasCredito: summary.diasCredito,
            correosExtra: summary.correosExtra || [],
        };
    }


    const handleGuardarBorrador = () => {
        const data = buildCurrentDraft();
        const existingId = drafts.currentDraftId || undefined;
        const id = drafts.saveDraft(data, { id: existingId });
        drafts.setCurrentDraftId(id);
        setSnackbarsConfig(p => ({
            ...p,
            open: true,
            text: existingId ? "Borrador actualizado." : "Borrador guardado en este navegador.",
            severity: "success"
        }));
    };






    const applyDraft = async (id: string) => {
        const draft = drafts.getDraft(id);
        if (!draft) return;

        // 1) Tipo y serie
        if (draft.data.tipo !== client.tipo) {
            client.handleChangeTipo(draft.data.tipo); // esto refresca series
        }
        if (draft.data.serie) {
            // dar tiempo a que series_get responda (ya lo maneja tu hook; reintento suave)
            setTimeout(() => client.setSerieByValue(draft.data.serie as string), 50);
        }

        // 2) Cliente
        client.selectClienteByIdOrObject(draft.data.selectedCliente as any);

        // 3) Productos
        products.loadProducts(draft.data.productosAgregados || []);

        // 4) Nota
        description.setNotaAdicional(draft.data.notaAdicional || "");

        // 5) Relacionados
        setCfdirelacionados?.(draft.data.cfdirelacionados || []);

        // 6) Resumen
        summary.setMetodoPago(draft.data.metodoPago);
        summary.setFormaPago(draft.data.formaPago);
        summary.setMoneda(draft.data.moneda);
        summary.setTipoCambio(Number(draft.data.tipoCambio || 0));
        summary.setDiasCredito(draft.data.diasCredito || "");
        summary.setCorreosExtra(draft.data.correosExtra || []);

        // 7) Marcar “borrador activo”
        drafts.setCurrentDraftId(id);

        setSnackbarsConfig((p) => ({ ...p, open: true, text: "Borrador cargado.", severity: "info" }));
    };


    const resetForNextDocument = async () => {
        products.resetProducts();
        description.reset();
        summary.reset();
        setCfdirelacionados([]);      // limpia relacionados primero
        client.clearCliente();        // <-- limpia información del cliente
        client.handleForceRefreshSeries(); // refresca serie/folio
        drafts.setCurrentDraftId(null);
    };



    // ---- modal QR desde eventos externos
    useEffect(() => {
        const handleOpenCreateFromQR = (ev: any) => {
            const data = ev.detail?.data;
            if (!data) return;
            setBpFormOpen(false);
            setTimeout(() => {
                setIsNewEntry(true);
                setMethodCustom(false);
                setOpenQr(false);
                setOpenImgQr(false);
                setBpIdentifier(null);
                setBpFormData(data);
                setBpFormOpen(true);
                setSnackbarsConfig((p) => ({
                    ...p,
                    open: true,
                    text: "Información del QR cargada automáticamente.",
                    severity: "info",
                }));
            }, 200);
        };
        window.addEventListener("bp:open-create-from-qr", handleOpenCreateFromQR);
        return () => window.removeEventListener("bp:open-create-from-qr", handleOpenCreateFromQR);
    }, []);



    const rlI = [
        { value: "04", label: "Sustitución de los CFDI previos" },
        { value: "06", label: "Factura generada por los traslados de previos" },
        { value: "07", label: "CFDI por aplicacion de anticipo" },
    ];

    const rl0E = [
        { value: "01", label: "Nota de crédito de los documentos relacionados" },
        { value: "02", label: "Nota de débito de los documentos relacionados" },
        { value: "03", label: "Devolucion de mercancías sobre facturas o trasladoas previos" },
        { value: "04", label: "Sustitución de los CFDI previos" },
        { value: "06", label: "Factura generada por los traslados de previos" },
    ];

    const relacionOptions = useMemo(() => {
        const placeholder = [{ value: "", label: "Selecciona un tipo de relación" }];
        if (client.tipo === "I") return [...placeholder, ...rlI];   // RLI
        if (client.tipo === "E") return [...placeholder, ...rl0E];  // RL0E
        return placeholder; // por si todavía no han elegido tipo
    }, [client.tipo]);


    // ---- UI
    return (
        <div className="invoice-form-container">
            <ProcessPanel
                asOverlay
                open={proc.open}
                onClose={() => { }}
                title={proc.title}
                steps={PROCESS_STEPS[proc.kind]}
                progress={proc.progress}
            />

            <SNACK_ALERT
                open={snackbarsConfig.open}
                text={snackbarsConfig.text}
                severity={snackbarsConfig.severity}
                size={snackbarsConfig.size}
                autoHideDuration={snackbarsConfig.autoHideDuration}
                anchorOrigin={snackbarsConfig.anchorOrigin}
                onClose={() => setSnackbarsConfig((prev) => ({ ...prev, open: false }))}
            />

            <CUSTOM_DIALOG
                title="Relacionar Factura"
                open={relModalOpen}
                onClose={close}
                size="md"
                component={
                    <JOIN_INVOICE
                        type={relacionOptions}
                        onSubmit={confirmRelacion}
                        rfc={client.selectedCliente?.rfc ?? ""}
                        onClose={close}
                    />
                }
            />

            <CUSTOM_DIALOG
                title="Borradores guardados"
                open={draftsModalOpen}
                onClose={() => setDraftsModalOpen(false)}
                size="md"
                component={
                    <Box sx={{ p: 1 }}>
                        {drafts.list.length === 0 ? (
                            <Typography color="text.secondary">No hay borradores guardados en este navegador.</Typography>
                        ) : (
                            <Stack spacing={1.25}>
                                {drafts.list.map(d => (
                                    <Paper key={d.id} variant="outlined" sx={{ p: 1.25, display: "flex", alignItems: "center", gap: 1 }}>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography fontWeight={700}>{d.title}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Guardado: {new Date(d.createdAt).toLocaleString()}
                                            </Typography>
                                        </Box>
                                        <Stack direction="row" spacing={1}>
                                            <Button size="small" variant="outlined" onClick={() => { applyDraft(d.id); setDraftsModalOpen(false); }}>
                                                Cargar
                                            </Button>
                                            <Button size="small" color="error" onClick={() => drafts.removeDraft(d.id)}>
                                                Eliminar
                                            </Button>
                                        </Stack>
                                    </Paper>
                                ))}
                            </Stack>
                        )}
                    </Box>
                }
            />



            {bpFormOpen && (
                <GENERAL_FORM
                    key={(open_qr ? "qr" : open_img_qr ? "qr_img" : isNewEntry ? "create" : "update") + bpFormOpen}
                    open={bpFormOpen}
                    onClose={() => setBpFormOpen(false)}
                    data_form={dataFormToUse}
                    onSave={handleSaveBP}
                    isNew={isNewEntry || open_qr || open_img_qr}
                    title_create="CREAR SOCIO DE NEGOCIOS"
                    title_update="ACTUALIZAR SOCIO DE NEGOCIOS"
                    validateField={validate_data}
                    handleProcessedFormat={processed_format}
                    FormData={client.clientesList}
                    original_data={{
                        ...bpFormData,
                        qrActive,
                        onCloseModal: () => setBpFormOpen(false),
                        data_businesspartners: client.clientesList,
                    }}
                    size={methodCustom && (open_qr || open_img_qr) ? "40%" : "80%"}
                    methodDelete={false}
                    methodCustom={methodCustom}
                    message_delete=""
                    updatedFormData={updated_form_data}
                    identifier_data={bpIdentifier ?? undefined}
                    loadingSkeleton={bpFormLoading}
                />
            )}

            {/* Menú QR */}

            <Menu
                id="qr-menu"
                MenuListProps={{ "aria-labelledby": "qr-button" }}
                anchorEl={client.qrAnchorEl}
                open={client.qrMenuOpen}
                onClose={client.handleCloseQRMenu}
                TransitionComponent={Fade}
            >
                <MenuItem onClick={handleOpenQRByCamera}>CREAR/ACTUALIZAR POR CÁMARA</MenuItem>
                <MenuItem onClick={handleOpenQRByImage}>CREAR/ACTUALIZAR POR IMAGEN</MenuItem>
            </Menu>

            <div className="invoice-columns">
                <div className="invoice-left">
                    <Client
                        cliente={client.selectedCliente}
                        onSelectCliente={client.onSelectCliente}
                        clientesList={client.clientesList}
                        tipo={client.tipo}
                        setTipo={client.handleChangeTipo}
                        seriesOptions={client.seriesOptions}
                        serie={client.selectedSerie?.serie || ""}
                        setSerieByValue={client.setSerieByValue}
                        folio={client.folio}
                        onRefreshSeries={client.handleForceRefreshSeries}
                        rfc={client.rfc}
                        usoCFDIValue={client.usoCFDIValue}
                        setUsoCFDIValue={client.setUsoCFDIValue}
                        regimenFiscal={client.regimenFiscal}
                        setRegimenFiscal={client.setRegimenFiscal}
                        regimenFiscalList={[]}
                        onRefreshClients={client.handleForceRefreshClients}
                        onCreateCliente={openCreatePartner}
                        onEditCliente={openEditPartner}
                        onOpenQRMenu={client.handleOpenQRMenu}
                        loadingSeries={client.seriesLoading}
                        errorSeries={client.seriesError}
                        loadingClients={client.clientsLoading}
                        errorClients={client.clientsError}
                        notify={(text: string, severity: "warning" | "info" | "error" | "success" = "warning") =>
                            setSnackbarsConfig((prev) => ({
                                ...prev,
                                open: true,
                                text,
                                severity,
                                size: "sm",
                                autoHideDuration: 10000,
                                anchorOrigin: { vertical: "bottom", horizontal: "right" },
                            }))
                        }
                    />

                    <Products
                        conceptos={products.conceptosList}
                        selectedConcept={products.selectedConcept}
                        setSelectedConcept={products.setSelectedConcept}
                        cantidad={products.cantidad}
                        setCantidad={products.setCantidad}
                        precio={products.precio}
                        setPrecio={products.setPrecio}
                        unidad={products.unidad}
                        setUnidad={products.setUnidad}
                        descripcion={products.descripcion}
                        setDescripcion={products.setDescripcion}
                        onAgregar={products.agregarConcepto}
                        productosAgregados={products.productosAgregados}
                        onEliminar={products.eliminarConcepto}
                        onLimpiar={products.limpiarConceptos}
                        agregando={products.addingConcept}
                        impuestoPreview={products.impuestoPreview}
                    />

                    <Description
                        descripcion={description.notaAdicional}
                        setDescripcion={description.setNotaAdicional}
                        debounceDelay={300}
                    />
                </div>

                <div className="invoice-right">
                    <InvoiceSummary
                        productos={products.productosAgregados}
                        onGenerar={() => handleGenerar()}
                        // Encabezado
                        tipoCE={client.tipo}
                        serie={client.selectedSerie?.serie || ""}
                        folio={client.folio}
                        // Correos
                        correosFijos={summary.correosFijos}
                        correosExtra={summary.correosExtra}
                        onChangeCorreosExtra={summary.setCorreosExtra}
                        // Cliente
                        cliente={
                            client.selectedCliente
                                ? {
                                    razonSocial: client.selectedCliente.business_partner,
                                    rfc: client.selectedCliente.rfc,
                                    usoCFDI: client.usoCFDIValue || client.selectedCliente.cfdi_use || "",
                                    regimen: client.regimenFiscal || client.selectedCliente.tax_regime || "",
                                }
                                : undefined
                        }
                        // Relacionados
                        onRelacionar={() => {
                            if (!client.selectedCliente) return;
                            open();
                        }}
                        relacionados={cfdirelacionados}
                        onEliminarRelacionado={remove}
                        relacionarDisabled={!client.selectedCliente}
                        relacionarTooltip={!client.selectedCliente ? "Selecciona un socio de negocios para poder relacionar..." : ""}
                        // Pago/Moneda
                        metodoPago={summary.metodoPago}
                        setMetodoPago={summary.setMetodoPago}
                        formaPago={summary.formaPago}
                        setFormaPago={summary.setFormaPago}
                        listaMetodoPago={listaMetodoPago}
                        listaFormaPago={listaFormaPago}
                        moneda={summary.moneda}
                        setMoneda={summary.setMoneda}
                        tipoCambio={summary.tipoCambio}
                        setTipoCambio={summary.setTipoCambio}
                        listaMonedas={listaMonedas}
                        // Crédito/nota
                        diasCredito={summary.diasCredito}
                        setDiasCredito={summary.setDiasCredito}
                        notaAdicional={description.notaAdicional}
                        // Flags de acciones
                        hasProductoSeleccionado={!!products.selectedConcept}
                        canGenerar={summary.canGenerar}
                        generarTooltip={summary.generarTooltip}
                        // Utilidades
                        onAplicarIVA={(precioConIVA: number | string) => {
                            const n = Number(precioConIVA);
                            if (!Number.isFinite(n) || n <= 0) return;
                            const base = n / 1.16;
                            products.setPrecio(base.toFixed(6));
                        }}

                        onGuardarBorrador={handleGuardarBorrador}     // <-- del paso de borradores
                        onAbrirBorradores={() => setDraftsModalOpen(true)}

                    />
                </div>
            </div>
        </div>
    );
}




